import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { RouteSegment } from '@core/enums/route-segment.enum';

import { PermissionStoreModelEnum } from '@domain/permissions/permissions.enums';

import {
  AlertingCardTableComponent,
  AlertingCardTableSortChangeEvent,
  AlertingCardTableViewModel,
} from '@shared/components/alerting-card-table';
import { MovablePanelTitleComponent } from '@shared/components/movable-panel-title';
import { MoveablePanelComponent } from '@shared/components/moveable-panel/moveable-panel.component';
import { PanelLinkComponent } from '@shared/components/panel-link';
import { HasPermissionPipe } from '@shared/pipes/has-permission/has-permission.pipe';

@Component({
  selector: 'app-site-alerts-movable-panel',
  imports: [
    MoveablePanelComponent,
    MovablePanelTitleComponent,
    AlertingCardTableComponent,
    TranslatePipe,
    RouterLink,
    PanelLinkComponent,
    HasPermissionPipe,
  ],
  templateUrl: './site-alerts-movable-panel.component.html',
  host: { class: 'flex flex-col' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteAlertsMovablePanelComponent {
  public vm = input<AlertingCardTableViewModel>();
  public isLoading = input<boolean>(false);
  public sortChange = output<AlertingCardTableSortChangeEvent>();

  public readonly RouteSegment = RouteSegment;
  public readonly Permission = PermissionStoreModelEnum;
}
